import { handleImageError } from "@/utils/GalleryFunctions";
import { SetStateAction, useState } from "react";
import { commentDate } from "@/utils/DateFormats";
import NewDiscussion from "../NewDiscussion/NewDiscussion";
import { ReportedElementI } from "@/interfaces/galleries/Galleries";
import { usePhotoViewContext } from "@/context/PhotoViewContext";
import { useGalleryContext } from "@/context/GalleryContext";
import { useRouter } from "next/navigation";

interface CommentPropsI {
  discussion: any;
  level?: number;
  viewOnly?: boolean;
  setReport?: React.Dispatch<
    SetStateAction<{ show: boolean; reportedElement: ReportedElementI | null }>
  >;
}

function Discussion(props: CommentPropsI) {
  const [reply, setReply] = useState<boolean>(false);
  const router = useRouter();

  const { photo } = usePhotoViewContext();
  const { gallery } = useGalleryContext();
  const { discussion, level, viewOnly, setReport } = props;

  const navigateProfile = () => {
    if (discussion.userId && discussion.userId.name) {
      router.push("/profile?user=" + discussion.userId.name);
    }
  };

  return (
    <div className="comment-component-main-container">
      <div className="main-commment-container">
        <img
          src={discussion.userId ? discussion.userId.avatar : ""}
          onError={handleImageError}
          onClick={navigateProfile}
          alt="user avatar"
        />
        <div className="comment-info-container">
          <div className="c-row">
            <h3>
              {discussion.userId?.name || "Account deleted"}{" "}
              {discussion.userId?.admin > 0 ? "(Moderator)" : ""}
            </h3>
          </div>
          <div className="c-row">
            <h4 className="font-light">{discussion.comment}</h4>
          </div>
          <div className="c-row">
            <p>
              <span className="points-text">{discussion.userId?.points}</span>{" "}
              points
            </p>
            <p>{commentDate(discussion.createdAt)}</p>
            {!viewOnly && (
              <>
                {(!level || level < 3) && (
                  <h5 role="button" onClick={() => setReply(!reply)}>
                    Reply
                  </h5>
                )}
                {setReport && (
                  <h5
                    role="button"
                    onClick={() =>
                      setReport({
                        show: true,
                        reportedElement: {
                          id: discussion._id,
                          galleryId: gallery!._id,
                          type: "discussion",
                          url: photo!.url,
                        },
                      })
                    }
                  >
                    Report
                  </h5>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="reply-container">
        {reply && (
          <NewDiscussion
            photoId={discussion.photoId}
            parentCommentId={discussion._id}
          />
        )}
      </div>
      <div className="sub-comments-container">
        {discussion.subComment.map((subComment: any, i: any) => {
          return (
            <Discussion
              setReport={setReport}
              discussion={subComment}
              level={(level ? level : 1) + 1}
              key={`sub-comment-${i}`}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Discussion;
